// extracted by mini-css-extract-plugin
export var callCard = "_qv-0";
export var callMessageButton = "_qv-1";
export var helpIcon = "_qv-3";
export var helpIconContainer = "_qv-4";
export var verticalDivider = "_qv-2";